import { posthog, type PostHog, type JsonType, type PostHogConfig } from 'posthog-js';

export const usePosthog = (options: Partial<PostHogConfig> = {}) => {
  const runtimeConfig = useRuntimeConfig();

  if (!import.meta.client) {
    return {
      posthog: null,
    };
  }

  const defaultClientOptions: Partial<PostHogConfig> = {
    api_host: runtimeConfig.public.posthogHost as string,
    person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
    capture_pageview: false, // we do not want to capture a pageview by default when initializing this client for the composable
    capture_pageleave: false,
    loaded: (posthog) => {
      // if (['development', 'staging', 'local'].includes(import.meta.env.MODE)) posthog.debug();
    },
  };
  const clientOptions = { ...defaultClientOptions, ...options };
  const posthogClient = posthog.init(
    runtimeConfig.public.posthogPublicKey as string,
    clientOptions
  );

  return {
    posthog: posthogClient,
  };
};
